<template>
    <div class="column">
        <table class="table is-fullwidth is-bordered">
            <thead>
            <tr>
                <th class="narrow"></th>
                <th>Cost Item</th>
                <th>Remarks</th>
                <th>Amount</th>
                <th class="narrow"></th>
            </tr>
            </thead>
            <tbody>
            <custom-invoice-costs-table-row v-for="(item, index) in items" :item="item" :index="index"></custom-invoice-costs-table-row>
            <custom-invoice-costs-table-create-row></custom-invoice-costs-table-create-row>
            </tbody>
        </table>
    </div>
</template>

<script>
    import CustomInvoiceCostsTableRow from './CustomInvoiceCostsTableRow'
    import CustomInvoiceCostsTableCreateRow from './CustomInvoiceCostsTableCreateRow'
    export default {
        components: {
            CustomInvoiceCostsTableRow,
            CustomInvoiceCostsTableCreateRow
        },
        computed: {
            items() {
                return this.$store.getters.getCustomInvoiceCostItems
            }
        }
    }
</script>

<style scoped>
    th {
        font-size: small;
    }
    .narrow {
        width: 15px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Invoices/CustomInvoice/CustomInvoiceCostsTable.vue